import { css } from 'design'
import { Button } from 'primitives/button'
import { Stack } from 'primitives/containers/stack'
import React, { useContext, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import Textarea from 'react-textarea-autosize'

import { WidgetHeaderBar } from '../../../components/live_chat_widget/widget_header_bar'
import { useAxios } from '../../../hooks/use_axios'
import { createNewLiveChat } from '../../../reduxes/slices/chats/actions'
import {
  getCurrentAnswers,
  getCurrentQuestion,
} from '../../../reduxes/slices/questions/selectors'
import { WidgetContext } from '../widget_page_router'
import { questionContainerStyles, spacerStyles } from './styles'

export const TextInput = () => {
  const currentQuestion = useSelector(getCurrentQuestion)
  const dispatch = useDispatch()
  const axios = useAxios()
  const [textareaValue, setTextareaValue] = useState('')
  const answers: any = useSelector(getCurrentAnswers)
  const { handleAnswerAction } = useContext(WidgetContext)

  const submit = (event: any) => {
    event.preventDefault()
    const formData = new FormData(event.target)
    const message = formData.get('message')
    if (!message) {
      return
    }
    dispatch(axios(createNewLiveChat({ html: message }))).then(() => {
      const next =
        answers[0]?.action?.includes('question:') ||
        answers[0]?.action?.includes('welcome_message:')
      if (next) {
        handleAnswerAction(answers[0])
      } else {
        setTextareaValue('')
      }
    })
  }

  const handleChange = (event: any) => {
    setTextareaValue(event.target.value)
  }

  return (
    <>
      <WidgetHeaderBar />
      <div className={spacerStyles()} />
      <Stack
        as={'form'}
        onSubmit={submit}
        gap={2}
        className={questionContainerStyles()}
        css={{
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'flex-end',
          zIndex: 1,

          h2: {
            textAlign: 'center',
          },
        }}
      >
        <h2>{currentQuestion.text}</h2>
        <Textarea
          minRows={5}
          maxRows={10}
          cols={1}
          name={'message'}
          className={textareaStyles()}
          value={textareaValue}
          onChange={handleChange}
          placeholder={'Enter a message'}
        />
        <Button
          variant={'primary'}
          className={btnStyles()}
          type={'submit'}
          disabled={!textareaValue}
        >
          {currentQuestion.data.button_text || 'Continue'}
        </Button>
      </Stack>
    </>
  )
}

const textareaStyles = css({
  resize: 'none',
  fontSize: '$2',
})

const btnStyles = css({
  height: 42,
})
